import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectOption } from 'software_products/redux/slice';
import { selectIsAddingToCart, selectOptionValueGroups, selectSelectedOptionIndex } from 'software_products/redux/selectors';
import OptionsRow from 'software_products/components/OptionsRow';

const PriceModifiers = () => {
  const dispatch = useDispatch();
  const optionValueGroups = useSelector(selectOptionValueGroups);
  const selectedOptionIndex = useSelector(selectSelectedOptionIndex);
  const isAddingToCart = useSelector(selectIsAddingToCart);
  const onOptionSelected = (index) => {
    dispatch(selectOption(index));
  };

  return <>
    <h6 className="options-title">
      Select a License Type
    </h6>
    <OptionsRow
      isAddingToCart={isAddingToCart}
      optionValueGroups={optionValueGroups}
      selectedOptionIndex={selectedOptionIndex}
      onOptionSelected={onOptionSelected}
    />
  </>;
};

export default PriceModifiers;